module.exports = __webpack_public_path__ + "static/media/pumpkinPie.57bb8c67.jpg";